import Vue from 'vue';
import {
  SAVE_COUNTER_SHOPPINGCART,
} from '@/store/mutation-types';

const shoppingcart = {
  namespaced: true,
  state: {
    radix: 10,
    counter: 0,
    total: 0,
    items: [],
  },
  mutations: {
    SET_SHOPPING_CART_INIT: (state, data) => {
      if (data) {
        Vue.set(state, 'items', data.items);
        Vue.set(state, 'counter', parseInt(data.counter, state.radix));
        Vue.set(state, 'total', parseInt(data.total, state.radix));
        Vue.ls.set(SAVE_COUNTER_SHOPPINGCART, state);
      }
    },
    UPDATE_STATE_SHOPPING_CART: (state) => {
      let total = 0;
      let counter = 0;
      state.items.forEach((item) => {
        counter += parseInt(item.quantity, state.radix);
        total += parseInt((item.quantity * item.item.price), state.radix);
      });

      Vue.set(state, 'counter', counter);
      Vue.set(state, 'total', total);

      Vue.ls.set(SAVE_COUNTER_SHOPPINGCART, state);
    },
    ADD_ITEM_SHOPPING_CART: (state, data) => {
      const option = state.items.filter(o => o.item.id === data.item.id);
      if (option.length === 1) {
        if (parseInt(option[0].quantity, state.radix)
          >= parseInt(option[0].item.stock, state.radix)) {
          option[0].quantity = parseInt(option[0].item.stock, state.radix);
        } else {
          option[0].quantity += data.quantity;
        }
      } else {
        state.items.push(data);
      }
    },
    UPDATE_ITEM_SHOPPING_CART: (state, data) => {
      if (Number.isNaN(parseInt(data.quantity, state.radix))
        || parseInt(data.quantity, state.radix) <= 0) {
        const option = state.items.filter(opt => opt.item.id === data.item.id);
        if (option.length === 1) {
          const index = state.items.indexOf(option[0]);
          if (index !== -1) {
            state.items.splice(index, 1);
          }
        }
      } else {
        const option = state.items.filter(o => o.item.id === data.item.id);
        if (option.length === 1) {
          if (parseInt(data.quantity, state.radix)
            >= parseInt(option[0].item.stock, state.radix)) {
            option[0].quantity = parseInt(option[0].item.stock, state.radix);
          } else {
            option[0].quantity = parseInt(data.quantity, state.radix);
          }
        }
      }
    },
    REMOVE_ITEM_SHOPPING_CART: (state, data) => {
      const option = state.items.filter(opt => opt.item.id === data.item.id);
      if (option.length === 1) {
        const index = state.items.indexOf(option[0]);
        if (index !== -1) {
          state.items.splice(index, 1);
        }
      }
    },
  },
  actions: {
    addToShoppingCart({ commit }, item) {
      commit('ADD_ITEM_SHOPPING_CART', item);
      commit('UPDATE_STATE_SHOPPING_CART');
    },
    updateShoppingCart({ commit }, item) {
      commit('UPDATE_ITEM_SHOPPING_CART', item);
      commit('UPDATE_STATE_SHOPPING_CART');
    },
    removeToShoppingCart({ commit }, item) {
      commit('REMOVE_ITEM_SHOPPING_CART', item);
      commit('UPDATE_STATE_SHOPPING_CART');
    },
    cleanShoppingCart({ commit }) {
      commit('SET_SHOPPING_CART_INIT', { items: [], total: 0, counter: 0 });
    },
  },
  getters: {
    counterInfo: state => state.counter,
    itemsInfo: state => state.items,
    totalInfo: state => state.total,
  },
};

export default shoppingcart;



// WEBPACK FOOTER //
// ./src/store/modules/buyer/shopping-cart.js